import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
// import { AuthProvider } from "./contexts/AuthContext";
import { BrokerConnectionsProvider } from './hooks/use-broker-connections'; // Added import
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PortfolioPage from './pages/Portfolio'; // Renamed/repurposed from TradierDashboardPage
import SchwabCallbackHandler from './components/SchwabCallbackHandler'; // Import SchwabCallbackHandler
import TastyTradeCallbackHandler from './components/TastyTradeCallbackHandler'; // Import TastyTradeCallbackHandler
import SchwabTokenDebugger from './components/SchwabTokenDebugger';
import OptionStrategyDashboard from './pages/OptionStrategyDashboard';
import MySubscription from './pages/MySubscription';
import Pricing from './pages/Pricing';
import ProtectedRoute from './components/ProtectedRoute';
import AuthenticatedLayout from './components/layouts/AuthenticatedLayout';
import PublicLayout from './components/layouts/PublicLayout';
import Signup from './pages/Signup';
import SignInPage from './pages/SignIn';
import BrokerConnections from './pages/BrokerConnections';
import './App.css';

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isProcessingCode, setIsProcessingCode] = useState(false);

  return (
    <>
      <Routes>
        {/* Home page with special handling */}
        <Route path="/" element={<Index />} />
        
        {/* Public routes with public layout */}
        <Route element={<PublicLayout />}>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/pricing" element={<Pricing />} />
        </Route>
        
        {/* Protected routes with authenticated layout */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AuthenticatedLayout />}>
            {/* <Route path="/schwabdashboard" element={<SchwabDashboard />} /> */} {/* Removed */}
            <Route path="/schwab-token-debug" element={<SchwabTokenDebugger />} />
            {/* <Route path="/callback" element={<SchwabDashboard />} /> */} {/* Changed to SchwabCallbackHandler */}
            <Route path="/callback" element={<SchwabCallbackHandler />} /> {/* Changed to SchwabCallbackHandler */}
            <Route path="/tastytrade-callback" element={<TastyTradeCallbackHandler />} /> {/* TastyTrade callback handler */}
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/optionstrategy" element={<OptionStrategyDashboard />} />
            <Route path="/subscription" element={<MySubscription />} />
            <Route path="/brokers" element={<BrokerConnections />} />
          </Route>
        </Route>
        
        {/* 404 page with public layout */}
        <Route element={<PublicLayout />}>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      
      <Sonner position="top-right" closeButton />
    </>
  );
}

const App = () => {
  const queryClient = new QueryClient();
  
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        {/* Pass future flags removed for react-router v6 */}
        <Router>
          <BrokerConnectionsProvider> {/* Added Provider */}
            <Routes>
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<Signup />} />
              <Route path="/*" element={<AppContent />} />
            </Routes>
          </BrokerConnectionsProvider> {/* Added Provider */}
        </Router>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
